import { DataVariants } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";


export enum EntryTypes {
  CLUSTER = "CLUSTER",
  STANDALONE_EQUIPMENT = "STANDALONE-EQUIPMENT",
  CLUSTER_SUBEQUIPMENT = "CLUSTER-SUBEQUIPMENT",
}

export const entryType: FieldSchema = {
  name: "entryType",
  data: {
    variant: DataVariants.ENUM,
    options: Object.values(EntryTypes),
  },
  display: {
    displayed: false
  },
  form: { label: "Entry type", disabled: true, displayed: false },
};
